<p class="header">{{ 'address' | translate }}</p>
<p class="text">{{ address?.street }}</p>
<p class="text">{{ address?.zip }} {{ address?.city }}</p>
<!-- <app-coordinates [lat]="lat || '-'" [lng]="lng || '-'"></app-coordinates> HIDE for now -->
